import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=7a77746e&scoped=true"
import script from "./AttributesTable.vue?vue&type=script&lang=js"
export * from "./AttributesTable.vue?vue&type=script&lang=js"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=7a77746e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a77746e",
  null
  
)

export default component.exports